export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: 'DD. MMM yyyy',
    },
    display: {
        dateInput: 'DD. MMM yyyy',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM yyyy',
    },
}